
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const ServicesEditor = () => {
  const columns = [
    { key: 'id', label: 'ID (slug)', type: 'text' },
    { key: 'title-en', label: 'Title (EN)', type: 'text' },
    { key: 'title-my', label: 'Title (MS)', type: 'text' },
    { key: 'description-en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description-my', label: 'Description (MS)', type: 'textarea' },
    { key: 'detail-title-en', label: 'Detail Title (EN)', type: 'text' },
    { key: 'detail-title-my', label: 'Detail Title (MS)', type: 'text' },
    { key: 'detail-desc-en', label: 'Detail Desc (EN)', type: 'textarea' },
    { key: 'detail-desc-my', label: 'Detail Desc (MS)', type: 'textarea' },
    { key: 'image', label: 'Image URL', type: 'image' },
    { key: 'milestones', label: 'Milestones (JSON)', type: 'json' },
  ];

  return <GenericTableEditor tableName="services" columns={columns} title="Services Manager" />;
};

export default ServicesEditor;
